import { createAction, props } from '@ngrx/store';

export const loginSuccess = createAction(
  '[Authentication] Login Success',
);

export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: unknown }>(),
);

export const accessTokenReceived = createAction(
  '[Authentication] Token Received',
  props<{
    expiresAt: number;
  }>(),
);
